export default __webpack_public_path__ + "OpenSans-ExtraBoldItalic-4014c9193f4880e35caa200ea160c529.ttf";